import { Request } from '../../../httpClient/serverApi/requests/Request';
import { ISiteLoginParams } from '../types/ISiteLoginParams';
import { IGetSessionInfoResult } from './GetSessionInfoRequest';

export class ClientCertificateLoginRequest extends Request<ISiteLoginParams, IGetSessionInfoResult> {
  constructor(params: ISiteLoginParams) {
    super('auth/clientCertificateLogin', params);
  }
}
